export default {
  type: 'list',
  title: `List`,
  icon: `list`,
  template: (config) => `
        <ul data-list_type="{{feature.list_type}}">
          <li
            ng-repeat="li in feature.items"
            ng-model="li.content"
            ng-bind-html="li.content"
            feature-obj="feature"
            org-index="orgIndex"
            data-index="${config.index}"
            contenteditablebind
            contenteditable="true"
            ng-keyup="countContent()"
            id="{{li._id}}"
            placeholder="Type your text here">
          </li>
        </ul>`,
  propertyTemplate: `<div class="form-group row">
        <label>List Type</label>
        <select
          class="form-control"
          id="search_{{$feature._id}}"
          ng-model="feature.list_type">
            <option value="ordered">numbered</option>
            <option value="unordered">bulleted</option>
        </select>
      </div>`,
  setIds: function (idFactory, obj) {
    obj.items.forEach((item) => {
      if (!item._id) {
        item._id = idFactory()
      }
    })
  },
  initialInflation: function () {
    return {
      type: 'list',
      list_type: 'unordered',
      items: [{ type: 'text', content: '' }],
    }
  },
  onPaste: function (elem) {
    const baseObj = {
      type: 'list',
      list_type:
        elem.prop('tagName').toLowerCase() === 'ol' ? 'ordered' : 'unordered',
      items: [],
    }

    elem.find('li').each(function () {
      baseObj.items.push({
        type: 'text',
        content: $(this).html(),
      })
    })
    return baseObj
  },
  openPropertyTemplateOnAdd: false,
}
